export const LABELS = {
  1: 'Thêm tỉnh/thành',
  2: 'Xóa tỉnh/thành',
  3: 'Nhập kho',
  4: 'Xem khoản chi',
  5: 'Tạo khoản chi',
  6: 'Xem lịch sử khoản chi',
  7: 'Sửa lịch sử khoản chi',
};

export const PERMISSIONS = {
  INSERT_PROVINCE_KEYWORD: 1,
  DELETE_PROVINCE_KEYWORD: 2,
  IMPORT_QT_PRODUCT: 3,
  VIEW_QT_EXPENSE: 4,
  EDIT_QT_EXPENSE: 5,
  VIEW_QT_EXPENSE_HISTORY: 6,
  EDIT_QT_EXPENSE_HISTORY: 7,
};
